export default __webpack_public_path__ + "static/media/Icono_pago_contra_entrega.08d9b937.svg";